// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6593) return "static/chunks/framework-f0486a883f1a3882.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1388":"33250c6b6c3debee","1500":"08ed13a96eca80c4","4938":"53e8235059e9e16b","7082":"4b4fb22461c75c2b"}[chunkId] + ".js";
};